@if (data) {
  <div [class]="['testimonial-block']" lgContainer>
    <div
      [ngClass]="{
        highlighted: isTestimonialBlockStyleHighlighted,
        standard: isTestimonialBlockStyleStandard,
        right: isImageLocationRight
      }"
    >
      @if (image && isTestimonialBlockStyleHighlighted) {
        <div
          [lgColLg]="4"
          [lgColMd]="5"
          [lgCol]="12"
          class="testimonial-block--image"
        >
          <dotcom-frontend-image
            [image]="image"
            class="testimonial-block__image"
          />
        </div>
      }

      <div
        [lgColLg]="isTestimonialBlockStyleHighlighted && image ? 4 : 8"
        [lgColMd]="isTestimonialBlockStyleHighlighted && image ? 5 : 10"
        [lgCol]="12"
        class="testimonial-block__content-container"
      >
        <div class="testimonial-block__contributor-container">
          @if (testimonialBlockContributorName) {
            <div
              [innerHTML]="testimonialBlockContributorName | safeHtml"
              [wysiwygContainer]="'Testimonial Component'"
              class="testimonial-block__contributor-name wysiwyg"
              dotcomFrontendWysiwyg
            ></div>
          }

          @if (testimonialBlockContributorDetails) {
            <div
              [innerHTML]="testimonialBlockContributorDetails | safeHtml"
              [wysiwygContainer]="'Testimonial Component'"
              class="testimonial-block__contributor-details wysiwyg"
              dotcomFrontendWysiwyg
            ></div>
          }
        </div>
        <div
          [innerHTML]="testimonialBlockText | safeHtml"
          [wysiwygContainer]="'Testimonial Component'"
          class="testimonial-block__text wysiwyg"
          dotcomFrontendWysiwyg
        ></div>
      </div>
    </div>
  </div>
}
